// Reopen Shopify's preferences UI without changing the visitor's consent.
let pending;
async function openPreferences() {
  if (!window.privacyBanner?.showPreferences) {
    await new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) return reject(new Error('Privacy service unavailable'));
      const timeout = setTimeout(() => reject(new Error('Privacy service timeout')), 12000);
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        clearTimeout(timeout);
        if (error) reject(error); else resolve();
      });
    });
  }
  if (!window.privacyBanner?.showPreferences) throw new Error('Preferences UI unavailable');
  await window.privacyBanner.showPreferences();
}
document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('[data-vv-cookie-preferences]');
  if (!link) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (pending) return;
  const error = link.parentElement.querySelector('[data-vv-cookie-error]');
  if (error) error.hidden = true;
  link.setAttribute('aria-busy', 'true');
  pending = openPreferences().catch(() => { if (error) error.hidden = false; }).finally(() => {
    link.removeAttribute('aria-busy');
    pending = null;
  });
}, true);
